import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { RouterProvider } from 'react-router-dom';
import { loginRequest } from './auth/msalConfig';
import { router } from './routes';

export function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <RouterProvider router={router} />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <LoginScreen />
      </UnauthenticatedTemplate>
    </>
  );
}

function LoginScreen() {
  const { instance } = useMsal();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'grey.100',
        p: 2,
      }}
    >
      <Card variant="outlined" sx={{ maxWidth: 420, width: '100%' }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h5" component="h1">
              Persped Irattár
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Jelentkezz be a Persped fiókoddal a folytatáshoz.
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => void instance.loginRedirect(loginRequest)}
            >
              Bejelentkezés
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
